export default {
  PERM_VIEW_MODULE_PAYMENTS: "Access the payments module",
  PERM_VIEW_ANY_PAYMENTS: "See all payments",
  PERM_VIEW_PAYMENTS: "See payment details",
  PERM_CREATE_PAYMENTS: "Create a payment",
  PERM_VIEW_MODULE_SUBSCRIPTIONS: "Access the subscriptions module",
  PERM_VIEW_ANY_SUBSCRIPTIONS: "See all subscriptions",
  PERM_VIEW_SUBSCRIPTIONS: "See subscription details",
  PERM_CREATE_SUBSCRIPTIONS: "Create a subscription",
  PERM_EDIT_SUBSCRIPTIONS: "Edit subscriptions",
  PERM_DELETE_SUBSCRIPTIONS: "Delete a subscription",
  PERM_VIEW_MODULE_PACKAGES: "Access the packages module",
  PERM_VIEW_ANY_PACKAGES: "See all packages",
  PERM_VIEW_PACKAGES: "See package details",
  PERM_CREATE_PACKAGES: "Create a package",
  PERM_EDIT_PACKAGES: "Edit packages",
  PERM_DELETE_PACKAGES: "Delete a package",
  PERM_VIEW_MODULE_CUSTOMERS: "Access the customers module",
  PERM_VIEW_ANY_CUSTOMERS: "See all customers",
  PERM_VIEW_CUSTOMERS: "See customer details",
  PERM_CREATE_CUSTOMERS: "Create a customer",
  PERM_EDIT_CUSTOMERS: "Edit customers",
  PERM_DELETE_CUSTOMERS: "Delete a customer",
  PERM_VIEW_MODULE_INVOICES: "Access the invoices module",
  PERM_VIEW_ANY_INVOICES: "See all invoices",
  PERM_VIEW_INVOICES: "See invoice details",
  PERM_CREATE_INVOICES: "Create an invoice",
  PERM_EDIT_INVOICES: "Edit invoices",
  PERM_DELETE_INVOICES: "Delete an invoice",
  PERM_VIEW_MODULE_PRODUCTS: "Access the products module",
  PERM_VIEW_ANY_PRODUCTS: "See all products",
  PERM_VIEW_PRODUCTS: "See product details",
  PERM_CREATE_PRODUCTS: "Create a product",
  PERM_EDIT_PRODUCTS: "Edit products",
  PERM_EDIT_OWN_PRODUCTS: "Edit own product",
  PERM_DELETE_PRODUCTS: "Delete products",
  PERM_VIEW_MODULE_ORGANIZATIONS: "Access the organizations module",
  PERM_VIEW_ANY_ORGANIZATIONS: "See all organizations",
  PERM_VIEW_ORGANIZATIONS: "See organization details",
  PERM_CREATE_ORGANIZATIONS: "Create an organization",
  PERM_EDIT_ORGANIZATIONS: "Edit organizations",
  PERM_EDIT_OWN_ORGANIZATIONS: "Edit own organization",
  PERM_DELETE_ORGANIZATIONS: "Delete organizations",
  PERM_VIEW_MODULE_RESELLERS: "Access the resellers module",
  PERM_VIEW_ANY_RESELLERS: "View all resellers",
  PERM_VIEW_RESELLERS: "View resellers details",
  PERM_CREATE_RESELLERS: "Create a reseller",
  PERM_EDIT_RESELLERS: "Edit resellers",
  PERM_EDIT_OWN_RESELLERS: "Edit own reseller",
  PERM_DELETE_RESELLERS: "Delete resellers",
  PERM_VIEW_MODULE_USERS: "Access the users module",
  PERM_VIEW_ANY_USERS: "View all users",
  PERM_VIEW_USERS: "View users details",
  PERM_CREATE_USERS: "Create a user",
  PERM_EDIT_USERS: "Edit users",
  PERM_DELETE_USERS: "Delete users",
  PERM_VIEW_MODULE_ROLES: "Access the roles module",
  PERM_VIEW_ANY_ROLES: "View all roles",
  PERM_VIEW_ROLES: "View roles details",
  PERM_CREATE_ROLES: "Create a role",
  PERM_EDIT_ROLES: "Edit roles",
  PERM_DELETE_ROLES: "Delete roles",
  PERM_VIEW_ANY_PERMISSIONS: "View all permissions",
  PERM_VIEW_PERMISSIONS: "View permissions details",
  PERM_VIEW_ANY_LOGS: "View all logs",
  PERM_VIEW_LOGS: "View log details",
  PERM_VIEW_MODULE_SUPPLY_RULES: "Access the supply rules module",
  PERM_VIEW_ANY_SUPPLY_RULES: "View all supply rules",
  PERM_VIEW_SUPPLY_RULES: "View the details of the supply rules",
  PERM_CREATE_SUPPLY_RULES: "Create a supply rule",
  PERM_EDIT_SUPPLY_RULES: "Edit supply rules",
  PERM_DELETE_SUPPLY_RULES: "Delete supply rules",
  PERM_EDIT_ESTABLISHMENTS_TARGETS: "Edit establishment targets",
  PERM_EDIT_ORDER_ITEM_TAX_GROUPS: "Edit applicable line taxes",
  PERM_CANCEL_SALES_INVOICES: "Cancel a sales invoice",
  PERM_REOPEN_WEEKLY_REPORTS: "Reopen a weekly report",
  PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_INVOICES: "Access the establishment internal invoices module",
  PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_INVOICES: "See all establishment internal invoices",
  PERM_VIEW_ESTABLISHMENT_INTERNAL_INVOICES: "See establishment internal invoice details",
  PERM_CREATE_ESTABLISHMENT_INTERNAL_INVOICES: "Create an establishment internal invoice",
  PERM_EDIT_ESTABLISHMENT_INTERNAL_INVOICES: "Edit establishment internal invoices",
  PERM_DELETE_ESTABLISHMENT_INTERNAL_INVOICES: "Delete an establishment internal invoice",
  PERM_VIEW_REPORTS_PRODUCTS: "Products Report",
  PERM_VIEW_REPORTS_POS_PRODUCTS: "Products Sold Report (POS)",
  PERM_VIEW_REPORTS_WEEKLY_REPORTS: "Weekly Reports Aggregate Report",
  PERM_VALIDATE_STOCK_MOVEMENTS: "Validate a stock movement",
  PERM_VIEW_MODULE_ESTABLISHMENT_INTERNAL_ORDERS: "Access the internal orders module",
  PERM_VIEW_ANY_ESTABLISHMENT_INTERNAL_ORDERS: "View all internal orders",
  PERM_VIEW_ESTABLISHMENT_INTERNAL_ORDERS: "View an internal order details",
  PERM_CREATE_ESTABLISHMENT_INTERNAL_ORDERS: "Create an internal order",
  PERM_EDIT_ESTABLISHMENT_INTERNAL_ORDERS: "Edit internal orders",
  PERM_DELETE_ESTABLISHMENT_INTERNAL_ORDERS: "Delete an internal order",
  PERM_PROVISION_ISTHERA_PRODUCTS: "Provision products to ISTHERA",
};
